<template>
  <div class="login-box">
    <logo></logo>
    <div>
      <div class="box box-widget widget-user">
        <div class="widget-user-header bg-gray-light">
          <h3 class="widget-user-username">{{ $t('general.welcome') }} {{ currentUser.name }}</h3>
        </div>
        <div class="box-footer no-padding">
          <ul class="nav nav-stacked">
            <li v-for="lawFirm in lawFirms" :key="lawFirm.id" @click="selectLawFirm(lawFirm.id)">
              <a href="#">{{ $t('law_firm_selection.access', { law_firm_name: lawFirm.name })}}
                <i class="fa fa-fw fa-angle-right pull-right"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import urlQueryParams from '../mixins/logo-url-query-params'
import Logo from '../components/common/Logo'
import { mapGetters, mapState, mapActions } from 'vuex'

// noinspection JSUnusedGlobalSymbols
export default {
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    ...mapState('lawFirms', [
      'lawFirms'
    ])
  },
  methods: {
    ...mapActions('lawFirms', [
      'updateSelectedLawFirm'
    ]),
    selectLawFirm (lawFirmId) {
      this.updateSelectedLawFirm(lawFirmId)
      this.$router.push({ name: 'home' })
    }
  },
  mixins: [urlQueryParams],
  components: {
    Logo
  }
}
</script>

<style lang="scss" scoped>
  .login-box {
    width: 500px;
  }

  .widget-user .widget-user-header {
    height: initial;
    border-bottom: solid 1px #DDDDDD;
    text-align: center;
  }

  li {
    i {
      margin-top: 2px;
    }
  }

  li:hover {
    line-height: 3em;
    font-weight: bold;

    i {
      margin-top: 14px;
    }
  }
</style>
